import { Injectable, inject } from '@angular/core';
import { CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { PaymentWebSocketService, StorageService } from '@gb-webapp/gb-app';

export interface OrderSummaryComponent {
  // Component interface - can be empty or have optional properties if needed
}

@Injectable({ providedIn: 'root' })
export class OrderSummaryDeactivateGuard implements CanDeactivate<OrderSummaryComponent> {
  private readonly paymentWebSocket = inject(PaymentWebSocketService);
  private readonly storageService = inject(StorageService);

  canDeactivate(
    component: OrderSummaryComponent,
    currentRoute: unknown,
    currentState: unknown,
    nextState?: RouterStateSnapshot
  ): boolean {
    // Only clear data if navigating away from checkout/payment-success routes
    // Don't clear if navigating between checkout and payment-success
    if (nextState) {
      const nextUrl = nextState.url;
      const isNavigatingToCheckout = nextUrl.includes('/checkout');
      const isNavigatingToPaymentSuccess = nextUrl.includes('/payment-success');
      const isNavigatingToInstallation = nextUrl.includes('/installation');

      // Only clear if NOT navigating to checkout, payment-success, or installation
      if (!isNavigatingToCheckout && !isNavigatingToPaymentSuccess && !isNavigatingToInstallation) {
        //  checkout storage
        this.storageService.clearCheckoutData();
      }
    } else {
      // If nextState is not available, clear data to be safe
      this.storageService.clearCheckoutData();
    }

    return true;
  }
}
